var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { useSelector } from 'react-redux';
import { ManageLayout, useToast, FormField, } from '@igblsln/control';
import { useAddReceiveSaleInvoiceMutation, useGetSourceOfFundsQuery } from '../apis';
import { AFTER_API_TIME, getClientProps, useGetNextDocNoQuery, useGetModeOfPaymentsQuery, useListBankQuery, convertDateValue, defaultDateFormat, inputNumberProps, useAppDispatch, setPromptNavigate, } from '@igblsln/store';
import { Dialog } from 'primereact/dialog';
export default function CreateDirectInvoiceModal({ displayModal, customDiscard, invoiceData }) {
    const { showSuccess, showError } = useToast();
    const [showingToast, setShowingToast] = useState(false);
    const manageLayoutRef = useRef();
    const [formData, setFormData] = useState({});
    const dispatch = useAppDispatch();
    const clientProps = getClientProps();
    const [selectedModeOfPay, setSelectedModeOfPay] = useState(null);
    const { data: modeOfPayments } = useGetModeOfPaymentsQuery({});
    const { data: banks } = useListBankQuery();
    const { data: sourceOfFunds } = useGetSourceOfFundsQuery();
    const selectedProjectType = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.common) === null || _a === void 0 ? void 0 : _a.selectedProjectType; });
    const normalizedProjectType = (selectedProjectType || "").toString().trim().toLowerCase();
    const isVillaOrResidential = normalizedProjectType === "villa" || normalizedProjectType === "residential";
    const { data: docData } = useGetNextDocNoQuery("SR", { refetchOnMountOrArgChange: true });
    const [addInvoice, { isLoading: isAdding }] = useAddReceiveSaleInvoiceMutation();
    const onSubmit = (values) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        try {
            if ((values === null || values === void 0 ? void 0 : values.amount) > (invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.pending_amount)) {
                showError("Amount Exceeds the Pending Amount", `Max Allowed for this invoice is ₹.${invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.pending_amount}`);
                return;
            }
            let body = Object.assign(Object.assign({}, values), { project_id: invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.project_id, invoice_id: invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.key, receipt_number: docData === null || docData === void 0 ? void 0 : docData.next_doc_id, amount: parseFloat(values === null || values === void 0 ? void 0 : values.amount), docid: "SR" });
            let resp;
            resp = yield addInvoice(Object.assign(Object.assign({}, body), clientProps)).unwrap();
            showSuccess('Success', resp.detail);
            dispatch(setPromptNavigate({ promptNavigate: false }));
            setShowingToast(true);
            setTimeout(() => {
                customDiscard();
            }, AFTER_API_TIME);
        }
        catch (error) {
            showError('An error occurred', ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.detail) || "We couldn't save your post, try again!");
        }
    });
    const renderForm = (control, _register, errors, getValues, setValue) => {
        return (React.createElement("div", null,
            React.createElement("div", { style: { border: '2px solid gray', padding: '5px 20px' } },
                React.createElement("div", { className: "flex" },
                    React.createElement(FormField, { label: "Invoice No", name: "invoice_no", className: "col-12 md:col-6 pl-0", control: control, errors: errors, leftSpan: 4, rightSpan: 6, formItem: {
                            component: InputText,
                            componentProps: {
                                maxLength: 25,
                                disabled: true,
                                value: invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.invoice_id
                            }
                        } }),
                    React.createElement(FormField, { label: "Customer Name", name: "customer_name", className: "col-12 md:col-6 pl-0", control: control, errors: errors, leftSpan: 4, rightSpan: 6, formItem: {
                            component: InputText,
                            componentProps: {
                                maxLength: 25,
                                disabled: true,
                                value: invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.customer_name
                            }
                        } })),
                isVillaOrResidential ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "flex" },
                        React.createElement(FormField, { label: "Project Name", name: "project_name", className: "col-12 md:col-6 pl-0", control: control, errors: errors, leftSpan: 4, rightSpan: 6, formItem: {
                                component: InputText,
                                componentProps: {
                                    maxLength: 25,
                                    disabled: true,
                                    value: invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.project_name
                                }
                            } }),
                        React.createElement(FormField, { label: "Invoice Amount (\u20B9)", name: "invoice_amount", className: "col-12 md:col-6 pl-0", control: control, errors: errors, leftSpan: 4, rightSpan: 6, formItem: {
                                component: InputText,
                                componentProps: {
                                    maxLength: 25,
                                    disabled: true,
                                    value: invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.invoice_amount
                                }
                            } })),
                    React.createElement("div", { className: "flex" },
                        React.createElement(FormField, { label: "Payment Schedule", name: "payment_stage_desc", className: "col-12 md:col-6 pl-0", control: control, errors: errors, leftSpan: 4, rightSpan: 6, formItem: {
                                component: InputText,
                                componentProps: {
                                    maxLength: 255,
                                    disabled: true,
                                    value: (invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.additional_charge_stage_desc) || (invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.payment_stage_desc) || ''
                                }
                            } }),
                        React.createElement(FormField, { label: "Pending Amount (\u20B9)", name: "pending_amount", className: "col-12 md:col-6 pl-0", control: control, errors: errors, leftSpan: 4, rightSpan: 6, formItem: {
                                component: InputText,
                                componentProps: {
                                    maxLength: 25,
                                    disabled: true,
                                    value: invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.pending_amount
                                }
                            } })),
                    React.createElement("div", { className: "flex" },
                        React.createElement(FormField, { label: "Date", name: "date", useExplicit: true, control: control, errors: errors, leftSpan: 4, rightSpan: 6, required: true, className: "col-12 md:col-6", convertValue: convertDateValue, formItem: {
                                component: Calendar,
                                componentProps: {
                                    showIcon: true,
                                    dateFormat: defaultDateFormat
                                }
                            } })))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "flex" },
                        React.createElement(FormField, { label: "Project Name", name: "project_name", className: "col-12 md:col-6 pl-0", control: control, errors: errors, leftSpan: 4, rightSpan: 6, formItem: {
                                component: InputText,
                                componentProps: {
                                    maxLength: 25,
                                    disabled: true,
                                    value: invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.project_name
                                }
                            } }),
                        React.createElement(FormField, { label: "Unit Name", name: "unit_name", className: "col-12 md:col-6 pl-0", control: control, errors: errors, leftSpan: 4, rightSpan: 6, formItem: {
                                component: InputText,
                                componentProps: {
                                    maxLength: 25,
                                    disabled: true,
                                    value: invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.unit_name
                                }
                            } })),
                    React.createElement("div", { className: "flex" },
                        React.createElement(FormField, { label: "Invoice Amount (\u20B9)", name: "invoice_amount", className: "col-12 md:col-6 pl-0", control: control, errors: errors, leftSpan: 4, rightSpan: 6, formItem: {
                                component: InputText,
                                componentProps: {
                                    maxLength: 25,
                                    disabled: true,
                                    value: invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.invoice_amount
                                }
                            } }),
                        React.createElement(FormField, { label: "Payment Schedule", name: "payment_stage_desc", className: "col-12 md:col-6 pl-0", control: control, errors: errors, leftSpan: 4, rightSpan: 6, formItem: {
                                component: InputText,
                                componentProps: {
                                    maxLength: 255,
                                    disabled: true,
                                    value: (invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.additional_charge_stage_desc) || (invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.payment_stage_desc) || ''
                                }
                            } })),
                    React.createElement("div", { className: "flex" },
                        React.createElement(FormField, { label: "Pending Amount (\u20B9)", name: "pending_amount", className: "col-12 md:col-6 pl-0", control: control, errors: errors, leftSpan: 4, rightSpan: 6, formItem: {
                                component: InputText,
                                componentProps: {
                                    maxLength: 25,
                                    disabled: true,
                                    value: invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.pending_amount
                                }
                            } })),
                    React.createElement("div", { className: "flex" },
                        React.createElement(FormField, { label: "Date", name: "date", useExplicit: true, control: control, errors: errors, leftSpan: 4, rightSpan: 6, required: true, className: "col-12 md:col-6", convertValue: convertDateValue, formItem: {
                                component: Calendar,
                                componentProps: {
                                    showIcon: true,
                                    dateFormat: defaultDateFormat
                                }
                            } }))))),
            React.createElement("div", { style: { border: '2px solid gray', margin: '10px auto' } },
                React.createElement("div", { className: 'pl-4 pt-4 grid p-fluid h-full' },
                    React.createElement(FormField, { label: "Source of Fund", name: "source_of_fund_id", className: "col-12 md:col-6 pl-0", required: true, control: control, errors: errors, leftSpan: 4, rightSpan: 6, formItem: {
                            component: Dropdown,
                            componentProps: {
                                showClear: true,
                                optionLabel: "name",
                                optionValue: "key",
                                filter: true,
                                filterBy: "name",
                                options: sourceOfFunds,
                            }
                        } }),
                    React.createElement(FormField, { label: "Amount", name: "amount", leftSpan: 4, rightSpan: 6, required: true, useExplicit: true, className: "col-12 md:col-6", control: control, errors: errors, formItem: {
                            component: InputNumber,
                            componentProps: Object.assign({}, inputNumberProps)
                        } }),
                    React.createElement(FormField, { label: "Mode of Payment", name: "payment_mode_id", className: "col-12 md:col-6 pl-0", required: true, control: control, errors: errors, leftSpan: 4, rightSpan: 6, onChange: (e) => {
                            var _a;
                            const selectedOption = modeOfPayments === null || modeOfPayments === void 0 ? void 0 : modeOfPayments.find((option) => option.modeofpay === e.value);
                            setSelectedModeOfPay(((_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.descr) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || e.value);
                        }, formItem: {
                            component: Dropdown,
                            componentProps: {
                                options: modeOfPayments,
                                optionLabel: 'descr',
                                optionValue: 'modeofpay'
                            }
                        } }),
                    selectedModeOfPay != "cash" &&
                        React.createElement(FormField, { label: "Account Name", name: "account_id", className: "col-12 md:col-6 pl-0", control: control, errors: errors, required: true, leftSpan: 4, rightSpan: 6, formItem: {
                                component: Dropdown,
                                componentProps: {
                                    options: banks,
                                    optionLabel: 'acc_name',
                                    optionValue: 'key'
                                }
                            } }),
                    React.createElement(FormField, { label: "Transaction Detail", name: "transaction_detail", leftSpan: 4, rightSpan: 6, 
                        // required
                        className: "col-12 md:col-6 pl-0", control: control, errors: errors, formItem: {
                            component: InputText,
                            componentProps: {
                                maxLength: 255,
                            }
                        } }),
                    React.createElement(FormField, { label: "Notes", name: "notes", leftSpan: 4, rightSpan: 6, 
                        // required
                        className: "col-12 md:col-6 pl-0", control: control, errors: errors, formItem: {
                            component: InputText,
                            componentProps: {
                                maxLength: 255,
                            }
                        } })))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { header: `Create Sale Receipt`, visible: displayModal, position: 'center', modal: true, style: { width: '70vw' }, onHide: () => {
                let element = document.getElementById('discard-btn');
                if (element) {
                    element.click();
                }
                else {
                    customDiscard();
                }
            }, draggable: false, resizable: false, closable: true },
            React.createElement(ManageLayout, { baseRoute: "/payment/vendorpayment", bottomControl: true, data: formData, hideHeader: true, customDiscard: customDiscard, ref: manageLayoutRef, isUpdating: isAdding, onSubmit: onSubmit, renderForm: renderForm }))));
}
